/* eslint-disable @typescript-eslint/naming-convention */
import { schema } from 'normalizr';

import {
  AnalysisReportEntry,
  Event,
  ExperimentAvailability,
  Rollout,
  RolloutTarget,
  RolloutVersion,
} from '../lib/App';

export const variable = new schema.Entity(
  'variables',
  {},
  { idAttribute: 'name' },
);

export const experiment = new schema.Entity(
  'experiments',
  {},
  { idAttribute: 'name' },
);

export const userWithRoles = new schema.Entity(
  'usersWithRoles',
  {},
  { idAttribute: 'userName' },
);

export const users = new schema.Entity('users', {}, { idAttribute: 'Email' });

export const populationSize = new schema.Entity(
  'populationSize',
  {},
  { idAttribute: 'populationSize' },
);

export const currentUser = new schema.Entity(
  'currentUser',
  {},
  { idAttribute: 'email' },
);

export const event = new schema.Entity(
  'events',
  {},
  { idAttribute: (obj: Event) => `${obj.src}-${obj.event}-${obj.stateName}` },
);

export const rollout = new schema.Entity(
  'rollouts',
  {},
  {
    idAttribute: (obj: Rollout) => `${obj.variable}--${obj.version}`,
    processStrategy: (obj: Rollout) => {
      const newRollout = { ...obj };
      newRollout.rollouts = newRollout.rollouts || [];
      newRollout.rollouts = newRollout.rollouts.map(
        (rolloutTarget: RolloutTarget) => {
          return {
            ...rolloutTarget,
            constraints: rolloutTarget.constraints || [],
          };
        },
      );
      return newRollout;
    },
  },
);

export const rolloutVersion = new schema.Entity(
  'rolloutVersions',
  { rollout },
  {
    idAttribute: (obj: RolloutVersion) =>
      `${obj.rollout.variable}--${obj.rollout.version}`,
  },
);

export const rolloutHistory = new schema.Entity(
  'rolloutHistory',
  {},
  { idAttribute: 'variable' },
);

export const triggerEvents = new schema.Entity(
  'triggerEvent',
  {},
  { idAttribute: (triggerEvent: string) => triggerEvent },
);

export const messageTemplate = new schema.Entity(
  'messageTemplates',
  {},
  { idAttribute: 'id' },
);

export const campaign = new schema.Entity(
  'campaigns',
  {},
  { idAttribute: 'name' },
);

export const variableStats = new schema.Entity(
  'variableStats',
  {},
  { idAttribute: 'name' },
);

export const interference = new schema.Entity(
  'interferences',
  {},
  { idAttribute: 'experiment' },
);

export const analysisConfig = new schema.Entity(
  'analysisConfigs',
  {},
  { idAttribute: 'analysisName' },
);

export const metric = new schema.Entity('metrics', {}, { idAttribute: 'id' });

export const availability = new schema.Entity(
  'availability',
  {},
  {
    idAttribute: (obj: ExperimentAvailability) =>
      `${obj.domain}--${obj.restrictBy}`,
  },
);

export const analysisReport = new schema.Entity(
  'analysisReport',
  {},
  { idAttribute: (obj: AnalysisReportEntry) => obj.name },
);
